<template>
	<svg
		id="uuid-06caf918-ec71-4ed6-8193-01509ee882b2"
		data-name="1m"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 511.72 511.72"
	>
		<path
			class="uuid-e8c00d4b-8474-404b-8412-c738d3fc7703"
			fill="#f79196"
			d="M511.72,239.77v215.06c0,31.42-25.47,56.89-56.89,56.89H239.77L511.72,239.77Z"
		/>
		<path
			fill="#f3f3f5"
			d="M494.95,16.55L16.55,494.95C6.33,484.66,0,470.48,0,454.83v-183.32L271.51,0h183.32c15.65,0,29.83,6.33,40.12,16.55Z"
		/>
		<path
			class="uuid-649a2342-7ff3-46e4-b46f-496bae263ddc"
			fill="#b3e1ce"
			d="M511.72,56.89V239.77L239.77,511.72H56.89c-15.77,0-30.03-6.41-40.34-16.77L494.95,16.55c10.36,10.31,16.77,24.57,16.77,40.34Z"
		/>
		<path
			class="uuid-e8c00d4b-8474-404b-8412-c738d3fc7703"
			fill="#f79196"
			d="M271.51,0L0,271.51V56.89C0,25.47,25.47,0,56.89,0h214.62Z"
		/>
	</svg>
</template>
